const Season12 = [
    {id: "3", value: "1季"}, 
    {id: "6", value: "2季"}, 
    {id: "9", value: "3季"}, 
    {id: "12", value: "4季"}
  ];  
  
  export default Season12  